import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PantallaCargando } from '@/components/Cargando';
import { BarChart3 } from 'lucide-react';

export default function WhatsAppInformes() {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/tenant/campaign-delivery/runs').then(r => {
      const items = r.data?.items || r.data || [];
      const wa = (Array.isArray(items) ? items : []).filter(x => {
        const c = (x.channel || x.planned_channel || '').toLowerCase();
        return c.includes('whatsapp') || c.includes('wa');
      });
      setRuns(wa.slice(0, 40));
    }).catch(() => setRuns([])).finally(() => setLoading(false));
  }, []);

  if (loading) return <PantallaCargando />;

  const ok = runs.filter(r => String(r.status || '').includes('completed') || r.status === 'test_success').length;
  const fail = runs.filter(r => String(r.status || '').includes('fail')).length;

  return (
    <div className="space-y-5" data-testid="wa-informes">
      <div>
        <h2 className="text-base font-semibold text-[#0F172A] flex items-center gap-2">
          <BarChart3 className="w-4 h-4" /> Informes de WhatsApp
        </h2>
        <p className="text-xs text-[#64748B]">Historial de envíos masivos por WhatsApp.</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-xl border bg-white p-4 text-center">
          <p className="text-3xl font-bold text-emerald-600">{ok}</p>
          <p className="text-[11px] text-[#94A3B8]">Completados / OK</p>
        </div>
        <div className="rounded-xl border bg-white p-4 text-center">
          <p className="text-3xl font-bold text-red-500">{fail}</p>
          <p className="text-[11px] text-[#94A3B8]">Fallidos</p>
        </div>
      </div>

      <div className="bg-white border rounded-xl overflow-hidden">
        <div className="px-3 py-2 border-b text-xs font-semibold">Últimos envíos</div>
        <div className="divide-y max-h-80 overflow-y-auto">
          {runs.length === 0 && (
            <p className="p-4 text-xs text-[#94A3B8]">Aún no hay envíos de WhatsApp registrados.</p>
          )}
          {runs.map((r, i) => (
            <div key={r.id || i} className="px-3 py-2 flex justify-between text-xs">
              <div>
                <p className="font-medium text-[#0F172A]">{r.name || r.campaign_name || 'Envío WA'}</p>
                <p className="text-[#94A3B8]">
                  {r.created_at ? new Date(r.created_at).toLocaleString('es-MX') : r.status}
                </p>
              </div>
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#F1F5F9] text-[#64748B] h-fit">
                {r.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
